import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { SearchConfusingAgendaDto } from '@docbay/schemas';
import { AgendaAPI } from 'integration/api/agenda';
import { ConfusingAgendasActions } from '../../../constants/actions';

/**
 * Fetches confusing agenda data.
 * @param data - An object containing the search data and a flag indicating whether it's on save.
 * @returns A promise that resolves with the fetched data or rejects with an error message if there was an Axios error.
 */
export const fetchConfusingAgenda = createAsyncThunk(
  ConfusingAgendasActions.fetchConfusingAgenda,
  async (
    data: { data: SearchConfusingAgendaDto; isOnSave: boolean },
    { rejectWithValue },
  ) => {
    try {
      const { data: responseData } = await AgendaAPI.fetchConfusingAgenda(
        data.data,
      );
      return responseData;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);
